"use client";

import ProjectHero from "@/components/pages/project/ProjectHero";
import DynamicContent from "app/DynamicContent";
import CTAFooter from "components/Footer/CTAFooter";
import { NiceToMeetYou } from "@/components/NiceToMeetYou";

export default function CustomPage({ page }) {
  return (
    <>
      <ProjectHero project={page} isProject={false} />
      <DynamicContent content={page.content} page={page} />

      <NiceToMeetYou />
    </>
  );
}
